import { AspectRatio, Box, Flex, Image, Text } from '@chakra-ui/react';

import { useState } from 'react';
import { RedeemTicket } from '~/types/resources/redeemTicket';
import { WebrollButton } from '../common/buttons/WebrollButton';
import { QRCodeModal } from './QRCodeModal';

type Props = {
  gachaID: string;
  redeemTickets: RedeemTicket[] | undefined;
};

export const UndeliveredHistoryCard: React.FC<Props> = (props: Props) => {
  const redeem =
    props.redeemTickets?.find(
      (redeemTickets) => redeemTickets.gacha_id === props.gachaID
    ) ?? undefined;
  const [showModal, setShowModal] = useState(false);
  return (
    <Box
      width="full"
      p="8px"
      bgColor="white"
      borderWidth="1px"
      borderColor="border"
      rounded="10px"
    >
      <Flex flexDir="column" w="full" gap={3}>
        <Flex flexDir="row" justify="space-between">
          <Flex w="50%" flexDir="column">
            <AspectRatio ratio={16 / 9}>
              <Image
                src={redeem?.gacha_image_url}
                objectFit="cover"
                rounded="lg"
              />
            </AspectRatio>
          </Flex>
          <Flex w="40%" flexDir="column" justify="space-between">
            <Text fontSize="md" fontWeight="bold" textAlign="start">
              {redeem?.gacha_name}
            </Text>
            <Text fontSize="md" textAlign="center">
              {redeem?.item_count}個の注文
            </Text>
          </Flex>
        </Flex>
        <WebrollButton onClick={() => setShowModal(true)} height="40px">
          受取QRコードを表示
        </WebrollButton>
        <QRCodeModal
          redeem={redeem}
          showModal={showModal}
          onClose={() => setShowModal(false)}
        />
      </Flex>
    </Box>
  );
};
